<div class="tw-p-2.5 tw-bg-base-text/[.04] tw-rounded-lg tw-mb-2.5">
  <div class="tw-flex tw-justify-between tw-items-center tw-mb-3">
    <span class="tw-text-lg tw-font-bold tw-text-base-text/60" translate>student.subject_selector.title</span>
  </div>

  <div class="tw-grid tw-grid-cols-4 tw-gap-2">
    <button
      *ngFor="let subject of subjects"
      kendoButton themeColor="base"
      class="tw-h-40 tw-p-2 tw-bg-base-text/[.08] tw-text-base-text/[.65] tw-rounded-lg tw-border-none tw-shadow-sm"
      [class.selected]="subject.name === selectedSubject"
      (click)="selectSubject(subject.name)"
    >
      <div class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-bg-gray-600">
        <img
          class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover tw-opacity-50"
          src="{{ assetsPath$ | async }}/images/subjects/{{ subject.name.toLowerCase() }}.jpeg"
        >
      </div>
      <span class="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-center tw-items-center tw-text-white">
        <fa-icon class="tw-text-xl" [icon]="subject.icon"></fa-icon>
        <span>{{ subject.name }}</span>
      </span>
      <div
        *ngIf="subject.name === selectedSubject"
        class="selected-badge tw-absolute tw-top-0 tw-right-0 tw-flex-col tw-justify-center tw-items-center tw-w-6 tw-h-6 tw-rounded-bl-lg tw-bg-success"
      >
        <fa-icon class="tw-text-white" [icon]="icons.faCheck"></fa-icon>
      </div>
    </button>
  </div>
</div>
